import { FieldMessage } from 'apiConnector/secondary-market/batch/base';
import { EditableFieldInfo } from 'components/shared/Blotter/Grid/blotter.model';
import { useMemo } from 'react';
import { getHigherLevel } from 'routes/secondary-market-batch/grid/utils/get-higher-level';
import { ApiLevel } from 'utils/http/httpClient.model';

const colorByLevel = {
  Critical: 'Warning',
  Error: 'Warning',
  Warning: 'Warning',
  Info: 'Info',
};

export function useGetHigherColor(validationMessages?: FieldMessage[], editableState?: EditableFieldInfo) {
  return useMemo(() => {
    const validationMessagesLevel = getHigherLevel(validationMessages ?? []);
    const validationMessagesErrorLevel = colorByLevel[validationMessagesLevel ?? 'Info'];

    const editableStateErrorLevel: ApiLevel | undefined = editableState?.errors
      ? 'Error'
      : editableState?.warnings
        ? 'Warning'
        : undefined;

    const errorLevel =
      validationMessagesErrorLevel === 'Critical'
        ? 'danger'
        : validationMessagesErrorLevel === 'Error' || editableStateErrorLevel === 'Error'
          ? 'danger'
          : validationMessagesErrorLevel === 'Warning' || editableStateErrorLevel === 'Warning'
            ? 'warning'
            : 'info';

    return errorLevel;
  }, [validationMessages, editableState]);
}
